/**
 * @generated SignedSource<<c2c7aa34d7ee3d2b09b5d0a86cd692ec>>
 * @relayHash 99e727b261ce3eea3fd57258ca660f27
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 99e727b261ce3eea3fd57258ca660f27

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contractNumbers"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propositionId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contractNumbers",
        "variableName": "contractNumbers"
      },
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      }
    ],
    "concreteType": "ContractResponse",
    "kind": "LinkedField",
    "name": "updateContractNumbers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Contract",
        "kind": "LinkedField",
        "name": "contract",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contractNumbers",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateContractNumbersMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateContractNumbersMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "99e727b261ce3eea3fd57258ca660f27",
    "metadata": {},
    "name": "UpdateContractNumbersMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "791baf0e06b1a13171413a5968a5824c";

export default node;
